export const REQUEST_CODE_TIME = 60;
export const OTP_TIMERS_STORAGE_KEY = 'jnj.pwa.otp-timers';
